import { TAlertProps } from '@@types/popup';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  ModalBodyProps,
  ModalFooterProps,
  ModalHeaderProps,
} from '@chakra-ui/react';
import React, { useRef, useState } from 'react';

export default function Alert({
  header,
  description,
  closePopup,
  resolve,
  cancelButtonText,
  confirmButtonText,
  isCancelButtonShow = true,
  isConfirmButtonShow = true,
  confirmButtonType = 'agree',
  bottom,
  renderer,
  handleClosePopup,
  footerComponet,
  ...restProps
}: TAlertProps & { closePopup: () => void }) {
  const cancelRef = useRef<HTMLButtonElement>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleOnClose = (flag: boolean) => {
    resolve(flag);
    closePopup();
  };

  return (
    <AlertDialog
      isOpen={true}
      leastDestructiveRef={cancelRef}
      onClose={() => handleOnClose(false)}
      closeOnEsc
      motionPreset="slideInBottom"
      isCentered
      {...restProps}
    >
      <AlertDialogOverlay>
        <AlertDialogContent w="auto" borderRadius="0" mx="10px">
          {renderer ? (
            <>
              {renderer({
                handleOnClose,
                Component: Object.assign({ Header, Body, Footer }),
              })}
            </>
          ) : (
            <>
              {header && <Header>{header}</Header>}
              <Body textAlign="center" py="16px">
                {description}
              </Body>
              <Footer p="0">
                {footerComponet ? (
                  footerComponet
                ) : (
                  <div className="flex justify-center items-center w-full">
                    {isCancelButtonShow && (
                      <Button
                        onClick={() => handleOnClose(false)}
                        w="full"
                        borderRadius="0"
                      >
                        {cancelButtonText || 'Close'}
                      </Button>
                    )}
                    {isConfirmButtonShow && (
                      <Button
                        borderRadius="0"
                        onClick={
                          handleClosePopup
                            ? () =>
                                handleClosePopup(handleOnClose, setIsLoading)
                            : () => handleOnClose(true)
                        }
                        className={`${
                          confirmButtonType === 'agree'
                            ? 'submit-button'
                            : 'danger-button'
                        } text-white`}
                        w="full"
                        isLoading={isLoading}
                      >
                        {confirmButtonText || 'Agree'}
                      </Button>
                    )}
                  </div>
                )}
              </Footer>
              {bottom && bottom}
            </>
          )}
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
const Header = ({ children, ...props }: ModalHeaderProps) => (
  <AlertDialogHeader fontSize="18px" textAlign="center" {...props}>
    {children}
  </AlertDialogHeader>
);
const Body = ({
  children,
  ...props
}: {
  children: React.ReactNode;
} & ModalBodyProps) => <AlertDialogBody {...props}>{children}</AlertDialogBody>;

const Footer = ({
  children,
  ...props
}: { children: React.ReactNode } & ModalFooterProps) => (
  <AlertDialogFooter {...props}>{children}</AlertDialogFooter>
);
